module.exports = __webpack_public_path__ + "static/media/iPad-Application-meridian-uae.0b7458bf.jpg";